import { ca } from '@cian/analytics';

const DEFAULT_FIELDS = { name: 'oldevent', action: 'Click', category: 'DailyrentLanding' };

export function caReadManifest() {
  ca('eventSite', {
    ...DEFAULT_FIELDS,
    label: 'ReadManifest',
  });
}

export function caPlaceAnAd() {
  ca('eventSite', {
    ...DEFAULT_FIELDS,
    label: 'PlaceAd',
  });
}

export function caGoToGuide() {
  ca('eventSite', {
    ...DEFAULT_FIELDS,
    label: 'GoToGuide',
  });
}

export function caJoinCommunity() {
  ca('eventSite', {
    ...DEFAULT_FIELDS,
    label: 'JoinCommunity',
  });
}
